import {Component, OnInit} from '@angular/core';
import {ErrorCodeComponent} from "../../shared";

@Component({
  selector: 'app-error-404',
  template: `
    <error-code
      code="404"
      title="Page not found!"
      message="This is not the web page you are looking for."
    ></error-code>
  `,
  standalone: true,
  imports: [ErrorCodeComponent],
})
export class Error404Component implements OnInit {
  ngOnInit(): void {
  }
}
